import angular from 'angular';
import AuthorizationService from './authorization.service';

export default angular.module('app.authorization', [])
  .service('AuthorizationService', AuthorizationService)
  .directive('authorization', ['AuthorizationService', AuthorizationService => ({
    restrict: 'A',
    link: (scope, elem, attrs) => {
      let permission = attrs.permission;
      if (permission) {
        permission = scope.$eval(permission);
      }
      let group = attrs.group;
      if (group) {
        group = scope.$eval(group);
      }
      let hasOne = attrs.hasOne;
      if (hasOne) {
        hasOne = scope.$eval(hasOne);
      }
      if (!_.isEmpty(permission)) {
        if (!AuthorizationService.canPerform(permission)) {
          elem.remove();
        }
      }
      if (!_.isEmpty(group)) {
        if (!AuthorizationService.belongsTo(group)) {
          elem.remove();
        }
      }
      if (!_.isEmpty(hasOne)) {
        if (!AuthorizationService.hasOne(hasOne)) {
          elem.remove();
        }
      }
    }
  })])
  .name;
